// src/screens/equipmentrentaladmin/.../mechanictalknow/MechanicTalkNow.jsx

import React from 'react';
import RentalAdminLayout from '../../../../../../layout/equipmentrentaladmin/RentalAdminLayout.js';
import MechanicChatModal from '../../../../../../components/user/maintain/mechanicchatmodal/MechanicChatModal.js';

const RentalMechanicTalkNow = () => {
    return (
        <RentalAdminLayout>
            <MechanicChatModal isRentalAdmin={true} />
        </RentalAdminLayout>
    );
};

export default RentalMechanicTalkNow;